jQuery(document).ready(function ($) {
	// Addons active state
	$('body').on('click', '.addon input', function () {
		$(this).closest('label').toggleClass('active');
	});

	$('body').on('click', '.addon .btn', function (e) {
		e.preventDefault();
		$(this).find('.loader').css('opacity', 1);
		const varID = $(this).attr('data-id');
		const productType = $(this).attr('data-type');
		UpsellAddNew(varID, 1, productType);
	});

	$('body').on('click', '.card--product .btn--atc', function () {
		const varID = $(this).attr('data-id');
		const productType = $(this).attr('data-type');
		addSingleProd(varID, 1, productType);
	});
});

// ATC Upsells
function UpsellAddNew(variantId, quantity = 1, type) {
	return fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify({
			id: variantId, // variant ID for the new product
			quantity: quantity,
			properties: {
				_type: type,
			},
		}),
	})
		.then((response) => {
			if (!response.ok)
				throw new Error(`Shopify returned ${response.status}`);
			return response.json();
		})
		.then(() => {
			// After adding, fetch the updated cart
			return fetch('/cart.js')
				.then((res) => res.json())
				.then((cart) => {
					updateMiniCart(cart);

					$('.addon .btn .loader').css('opacity', 0);
				});
		})
		.catch((error) => {
			console.error('Add to cart failed:', error);
			const errorBox = document.querySelector('.minicart-error');
			if (errorBox) {
				errorBox.textContent = '⚠️ Could not add product to cart.';
				errorBox.style.display = 'block';
			}
		});
}

// ATC Upsells
function addSingleProd(variantId, quantity = 1, type) {
	return fetch('/cart/add.js', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify({
			id: variantId, // variant ID for the new product
			quantity: quantity,
			properties: {
				_type: type,
			},
		}),
	})
		.then((response) => {
			if (!response.ok)
				throw new Error(`Shopify returned ${response.status}`);
			return response.json();
		})
		.then(() => {
			// After adding, fetch the updated cart
			return fetch('/cart.js')
				.then((res) => res.json())
				.then((cart) => {
					updateMiniCart(cart);

					$('.addon .btn .loader').css('opacity', 0);
				});
		})
		.catch((error) => {
			console.error('Add to cart failed:', error);
			const errorBox = document.querySelector('.minicart-error');
			if (errorBox) {
				errorBox.textContent = '⚠️ Could not add product to cart.';
				errorBox.style.display = 'block';
			}
		});
}
